import { useDroppable } from '@dnd-kit/core';
import { CandidateStatus, CandidateSummary } from '@recruitai/shared';
import { CandidateCard } from './CandidateCard';

export interface KanbanColumnProps {
  status: CandidateStatus;
  label: string;
  color: string;
  count: number;
  candidates: CandidateSummary[];
  isValidTarget: boolean | null;
  isReadOnly: boolean;
  onCandidateClick: (candidateId: string) => void;
  onQuickReject: (candidateId: string) => void;
  onQuickAdvance: (candidateId: string) => void;
}

export function KanbanColumn({
  status,
  label,
  color,
  count,
  candidates,
  isValidTarget,
  isReadOnly,
  onCandidateClick,
  onQuickReject,
  onQuickAdvance,
}: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id: status });

  let borderClass = 'border-transparent';
  if (isValidTarget === true) {
    borderClass = isOver ? 'border-primary ring-2 ring-primary/30' : 'border-primary/50';
  } else if (isValidTarget === false) {
    borderClass = 'opacity-50';
  }

  return (
    <div
      ref={setNodeRef}
      className={`flex flex-col min-w-[280px] w-[280px] rounded-lg border-2 transition-all ${borderClass}`}
    >
      {/* Header */}
      <div className={`${color} rounded-t-lg px-3 py-2 flex items-center justify-between`}>
        <span className="font-semibold text-sm">{label}</span>
        <span className="bg-white/80 text-xs font-bold px-2 py-0.5 rounded-full">{count}</span>
      </div>

      {/* Cards */}
      <div className="flex-1 overflow-y-auto p-2 max-h-[calc(100vh-280px)] bg-gray-50/50">
        {candidates.length === 0 ? (
          <p className="text-xs text-muted-foreground text-center py-4">Nenhum candidato</p>
        ) : (
          candidates.map((c) => (
            <CandidateCard
              key={c.candidateId}
              candidate={c}
              isReadOnly={isReadOnly}
              onCandidateClick={onCandidateClick}
              onQuickReject={onQuickReject}
              onQuickAdvance={onQuickAdvance}
            />
          ))
        )}
      </div>
    </div>
  );
}
